import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
} from '@mui/material';
import { UsageTrackingEntry } from '../../interfaces/usage';
import { LoadTrackingEntriesByDateRange } from '../../hooks/usage/useUsageTracker';

interface SuggestionTrackerTableProps {
  data: UsageTrackingEntry[];
  onViewClick: (entry: UsageTrackingEntry) => void;
  loadTrackingEntriesByDateRange: LoadTrackingEntriesByDateRange;
  page: number;
  hasMore: boolean;
}

const SuggestionTrackerTable: React.FC<SuggestionTrackerTableProps> = (
  { data, onViewClick, loadTrackingEntriesByDateRange, page, hasMore }
) => {
  return (
    <TableContainer 
      component={Paper} 
      sx={{ 
        marginTop: '2rem',
        maxHeight: '600px', // Add a max height
        overflow: 'auto'    // Enable scrolling
      }}
    >
      <Table stickyHeader>
        <TableHead>
          <TableRow>
            <TableCell>External Ticket ID</TableCell>
            <TableCell>Suggestion Type</TableCell>
            <TableCell>Suggestion Subtype</TableCell>
            <TableCell>Is Approved</TableCell>
            <TableCell>Is Reported Wrong</TableCell>
            <TableCell>Action</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((entry) => (
            <TableRow key={`${entry.id}-${entry.suggestion_type}`}>
              <TableCell>{entry.external_ticket_id || 'N/A'}</TableCell>
              <TableCell>{entry.suggestion_type}</TableCell>
              <TableCell>{entry.suggestion_subtype || 'N/A'}</TableCell>
              <TableCell>{entry.is_approved ? 'Yes' : 'No'}</TableCell>
              <TableCell>{entry.is_reported_wrong ? 'Yes' : 'No'}</TableCell>
              <TableCell>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => onViewClick(entry)}
                >
                  View
                </Button>
              </TableCell>
            </TableRow>
          ))}
          {hasMore && (
            <TableRow>
              <TableCell colSpan={6} style={{ textAlign: 'center' }}>
                <Button onClick={() => loadTrackingEntriesByDateRange(page + 1)}>Load More</Button>
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default SuggestionTrackerTable;
